const errorHandler = (code) => {
if (code === 300){
    window.location = '/'
}
}
export default errorHandler; 